{
  "errorBoundary": {
    "title": "Algo quebrou nesta tela",
    "description": "Tire um print desta tela e envie. Os detalhes técnicos abaixo apontam exatamente onde ocorreu.",
    "stack": "Componente / stack",
    "reload": "Recarregar",
    "goHome": "Voltar ao início"
  },
  "auth": {
    "poweredBy": "Powered by <brand>Xtreed</brand>"
  },
  "student": {
    "collapseMenu": "Recolher menu",
    "expandMenu": "Expandir menu",
    "openMenu": "Abrir menu",
    "defaultLevel": "Iniciante",
    "xp": "{{value}} XP",
    "menu": "Menu",
    "nav": {
      "home": "Home",
      "courses": "Cursos",
      "ranking": "Ranking",
      "community": "Comunidade",
      "certificates": "Certificados",
      "profile": "Perfil"
    },
    "comingSoon": "Em breve",
    "logout": "Sair",
    "welcome": "<muted>Bem-vindo de volta,</muted> <name>{{name}}</name>",
    "admin": "Admin",
    "lightMode": "Modo Claro",
    "darkMode": "Modo Escuro",
    "myProfile": "Meu Perfil"
  },
  "admin": {
    "badge": "Admin",
    "groups": {
      "overview": "Visão Geral",
      "content": "Conteúdo",
      "commercial": "Comercial",
      "community": "Comunidade",
      "platform": "Plataforma"
    },
    "nav": {
      "dashboard": "Dashboard",
      "courses": "Cursos",
      "modules": "Módulos",
      "videos": "Vídeos",
      "categories": "Categorias",
      "certificates": "Certificados",
      "accessGroups": "Grupos de Acesso",
      "members": "Membros",
      "customFields": "Campos do Perfil",
      "surveys": "Pesquisas",
      "gamification": "Gamificação",
      "videoUsage": "Uso de vídeo",
      "settings": "Configurações"
    },
    "closeMenu": "Fechar menu",
    "collapseMenu": "Recolher menu",
    "expandMenu": "Expandir menu",
    "openMenu": "Abrir menu",
    "backToApp": "Voltar ao App",
    "logout": "Sair",
    "panelTitle": "Painel Administrativo",
    "online": "Online",
    "assistant": {
      "open": "Abrir assistente",
      "close": "Recolher assistente",
      "banner": {
        "title": "Conheça o Assistente Xtreed",
        "subtitle": "Ele monta cursos, módulos e aulas por você, escreve descrições e publica tudo na área de membros. Basta conversar.",
        "dontShowAgain": "Não mostrar novamente",
        "close": "Fechar",
        "seeNow": "Ver agora"
      }
    }
  }
}
